// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OoF2G","colBig":"styles_colBig__w9td5","colSmall":"styles_colSmall__1yfrN"};